<template>
  <v-select
    :key="`${gender}${readonly}`"
    v-model="gender"
    :items="genders"
    :rules="rules"
    :label="title"
    :clearable="!readonly"
    clear-icon="fas fa-times"
    :append-icon="readonly ? '' : undefined"
    item-text="name"
    item-value="gender"
    hide-details
    outlined
    :readonly="readonly"
    dense
  >
    <template slot="label">
      <v-icon
        style="vertical-align: middle; color:inherit; margin-top: -6px; transition: unset;"
        small
      >
        {{ icon }}
      </v-icon>
      {{ title }}
    </template>
    <template slot="prepend-inner" v-if="gender">
      <v-icon class="mr-2">{{
        genders.filter(g => g.gender == gender)[0].icon
      }}</v-icon>
    </template>
    <template slot="item" slot-scope="data">
      <v-icon v-if="data.item.icon" small class="mr-2">{{
        data.item.icon
      }}</v-icon
      >{{ data.item.name }}
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    parentGender: {
      type: String,
      default: "null"
    }
  },
  data() {
    return {
      title: "Gender",
      readonly: false,
      gender: null,
      rules: [],
      genders: [
        {
          gender: "male",
          name: "Male",
          icon: "fas fa-male"
        },
        {
          gender: "female",
          name: "Female",
          icon: "fas fa-female"
        }
      ]
      //childMessage: ""
    };
  },

  created() {
    if (this.parentGender) {
      this.gender = this.parentGender;
    }
    if (!this.gender && !(Object.entries(this.$route.query).length === 0)) {
      const { gender } = this.$route.query;
      //assign to current instance variables
      this.gender = gender;
    }
  },
  computed: {
    icon: function() {
      if (this.readonly) {
        return "fas fa-lock";
      } else if (this.required) {
        return "fas fa-asterisk";
      } else {
        return "";
      }
    }
  },
  methods: {
    // Define the method that emits data to the parent as the first parameter to `$emit()`.
    // This is referenced in the <template> call in the parent. The second parameter is the payload.
    // emitToParent (eevnt) {
    //   this.$emit('childToParent', this.childMessage)
    // }
  },
  watch: {
    gender: function() {
      this.$emit("change-gender", this.gender);
    }
  }
};
</script>
